import AccessTimeIcon from '@material-ui/icons/AccessTime'
import { styled } from '@material-ui/styles'
import { Box, Typography } from '@mui/material'
import CircularProgress, {
  circularProgressClasses
} from '@mui/material/CircularProgress'
import dayjs from 'dayjs'
import isToday from 'dayjs/plugin/isToday'
import { isEmpty } from 'lodash'
import React from 'react'

import { centreScheduleBatchTypes, programsMap } from 'app/config'

import { batchTypesColorList, scheduleColors } from '../config'
import * as styles from '../styles'
import { colors } from 'app/theme/colors'

dayjs.extend(isToday)

const BorderCircularProgress = styled(CircularProgress)((props) => {
  const backgroundColor =
    props.bgcolor ||
    (props.iscolorenabled === 'true' ? colors.ohGray : '#e0e0e0')
  const progressColor =
    props.progresscolor ||
    (props.iscolorenabled === 'true' ? colors.ohRed : colors.ohTeal)
  return {
    [`&.${circularProgressClasses.root}`]: {
      backgroundColor: 'transparent',
      borderRadius: '50%'
    },
    [`& .${circularProgressClasses.circle}`]: {
      stroke: backgroundColor
    },
    [`& .${circularProgressClasses.circleDeterminate}`]: {
      stroke: progressColor
    }
  }
})

function FacebookCircularProgress(props) {
  return (
    <Box sx={{ position: 'relative' }}>
      <CircularProgress
        variant="determinate"
        sx={(theme) => ({
          color:
            props.iscolorenabled === 'true' ? colors.ohRed : colors.ohGray
        })}
        size={40}
        thickness={4}
        {...props}
        value={100}
      />
      <CircularProgress
        variant="determinate"
        disableShrink
        sx={(theme) => ({
          color:
            theme.palette.mode === 'dark' || theme.palette.type === 'dark'
              ? colors.ohTeal
              : colors.ohTeal,
          animationDuration: '0ms',
          position: 'absolute',
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round'
          }
        })}
        size={40}
        thickness={4}
        {...props}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '40px',
          width: '40px'
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{
            color: 'text.secondary',
            fontFamily: 'AvenirDemi',
            fontSize: '10px',
            letterSpacing: '0em'
          }}
        >
          {`${props.attendedCount}/${props.reservedCount}`}
        </Typography>
      </Box>
    </Box>
  )
}

export const Card = (props) => {
  const { value, index, iscolorenabled } = props
  const reservedCount = value?.reserved_count
  const attendedCount = value?.attended_count

  let teacher
  if (
    programsMap.includes(value?.batch?.type) &&
    !isEmpty(value?.schedule_activities)
  ) {
    if (value?.schedule_activities.length === 1) {
      teacher = value?.schedule_activities[0]?.teacher?.user?.full_name
    } else {
      teacher = value?.schedule_activities?.reduce((prev, curr, currIndex) => {
        prev += curr?.teacher?.user?.full_name
          ? (currIndex > 0 ? ' & ' : '') + `${curr?.teacher?.user?.full_name}`
          : ''
        return prev
      }, '')
    }
  } else {
    teacher = value?.batch?.teacher?.full_name
  }
  const percentageEnrolments = attendedCount / reservedCount
  const standards = value?.batch?.course?.standards?.map((std) => std.name)

  return (
    <styles.CardContainer key={index}>
      <styles.CardHeader
        batchTypeColor={
          batchTypesColorList[iscolorenabled ? 'disabled' : value?.batch?.type]
        }
      >
        <styles.Room>
          <styles.Time>
            <styles.Icon>
              <AccessTimeIcon fontSize="inherit" />
            </styles.Icon>
            <styles.Boldtext>
              {dayjs('1/1/1 ' + value?.start_time).format('h:mmA')} -{' '}
              {dayjs('1/1/1 ' + value?.end_time).format('h:mmA')}
            </styles.Boldtext>
          </styles.Time>
        </styles.Room>
        <styles.Mediumheading>
          {centreScheduleBatchTypes[value?.batch?.type]}
        </styles.Mediumheading>
      </styles.CardHeader>
      <styles.CardBody>
        <styles.Info>
          <styles.Subtitle>{`${standards[0]} ${
            standards.length > 1 ? `- ${standards[standards.length - 1]}` : ''
          }`}</styles.Subtitle>
          <styles.Name color={scheduleColors[index]}>
            {value?.batch?.course?.subjects?.map((b) => b.name).join(' &  ')}
          </styles.Name>
          {
            <styles.Subheading>
              {teacher ? `with ${teacher}` : null}
            </styles.Subheading>
          }
        </styles.Info>
        {value?.cancelled ? (
          <styles.Boldheading>{`session cancelled`}</styles.Boldheading>
        ) : (
          <styles.Attendance>
            <FacebookCircularProgress
              value={
                reservedCount
                  ? percentageEnrolments * 100 <= 100
                    ? percentageEnrolments * 100
                    : 100
                  : 0
              }
              iscolorenabled={iscolorenabled.toString()}
              attendedCount={attendedCount}
              reservedCount={reservedCount}
            />
          </styles.Attendance>
        )}
      </styles.CardBody>
    </styles.CardContainer>
  )
}

export default Card
